import { format } from "date-fns";
import { useContext } from "react";
import { AuthContext } from "../AuthContext";
import { SendLiveComment } from "./GeneralClasses";

export const EmojisSheetContent = ({url,closeEmojiLsheet}) => {
    const docID = format(new Date(),"yyyyMMddHHmmss");
   const date = format(new Date(), "yyyy-MM-dd");
   const alphabets = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
   const randomUUid = `${Math.floor(Math.random() * 10000)}${alphabets.charAt(Math.floor(Math.random() * alphabets.length))}`
   const timestamp = new Date().getTime();
   const {userName} = useContext(AuthContext);
   const {profile_pic} = useContext(AuthContext);
   const {verifiedUid} = useContext(AuthContext);
   const {bloggerid} = useContext(AuthContext);

   const handleSendComment=()=>{
    if(verifiedUid){
       SendLiveComment(docID,userName,bloggerid,"",profile_pic,url,timestamp,date)
       .then((res)=>{
          if(res === true){
            closeEmojiLsheet(true);
          }
       }).catch((err)=>{

       });
    }else{
       let tempName = localStorage.getItem("userName");
       if(!tempName){
          localStorage.setItem("userName",`hbrUser${randomUUid}`);
          tempName = localStorage.getItem("userName");
          SendLiveComment(docID,tempName,bloggerid,"",profile_pic,url,timestamp,date)
          .then((res)=>{
             if(res === true){
                closeEmojiLsheet(true);
             }
          }).catch((err)=>{
 
          });
        
       }else{
        SendLiveComment(docID,tempName,bloggerid,"",profile_pic,url,timestamp,date)
          .then((res)=>{
             if(res === true){
                closeEmojiLsheet(true);
             }
          }).catch((err)=>{
 
          });
       }
 
    }
 };



    return ( 
    <div className="emojiscontent">
        <img src={url} alt="emoji" style={{width:"3em",height:"3em",objectFit:"contain",cursor:"pointer"}}
            onClick={()=>handleSendComment()}
        />
    </div> 
    );
}